import { render, staticRenderFns } from "./module3.vue?vue&type=template&id=3553342c&scoped=true"
import script from "./module3.vue?vue&type=script&lang=js"
export * from "./module3.vue?vue&type=script&lang=js"
import style0 from "./module3.vue?vue&type=style&index=0&id=3553342c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3553342c",
  null
  
)

export default component.exports